import React from 'react'
import PropTypes from 'prop-types'

import TimePicker from 'material-ui/TimePicker'
import timeIcon from '../../../../resources/time_icon.png'

export default class TimeInput extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    style: PropTypes.any
  }

  render() {
    return (
      <div style={{ ...styles.pickerContainer, ...this.props.style }}>
        <TimePicker
          id={'startTime'}
          underlineShow={false}
          inputStyle={styles.text}
          textFieldStyle={styles.textContainer}
          value={this.props.value}
          onChange={this.props.onChange} />
        <img
          style={styles.timeIcon}
          src={timeIcon} />
      </div>
    )
  }

}

const styles = {

  pickerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: 'white',
    justifyContent: 'space-around',
    height: 32,
    width: 132,
    cursor: 'pointer',
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    borderRadius: 3,
    paddingLeft: 6,
    paddingRight: 6
  },

  text: {
    color: '#757575',
    fontSize: 14
  },

  textContainer: {
    width: 100    
  },

  timeIcon: {
    width: 20,
    height: 20
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/TimeInput.js